/* Cascading category menu: hover or focus a category in the left column to swap
   which item list shows on the right; clicking a category follows its link. Self-contained per instance, keyed by data-pml-cat/data-pml-panel. */
(function () {
  function init(container) {
    var buttons = container.querySelectorAll('.pml-cascade-menu__cat-btn');
    var panels = container.querySelectorAll('.pml-cascade-menu__panel');

    function activate(catIndex) {
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-pml-cat') === catIndex;
        b.classList.toggle('is-active', active);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-pml-panel') === catIndex);
      });
    }

    buttons.forEach(function (btn) {
      var catIndex = btn.getAttribute('data-pml-cat');
      /* Hovering with a mouse swaps the panel; clicking then follows the link. */
      btn.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') activate(catIndex);
      });
      /* Keyboard focus swaps the panel too (Enter then follows the link). */
      btn.addEventListener('focus', function () {
        if (btn.matches(':focus-visible')) activate(catIndex);
      });
      /* Touch screens have no hover: the first tap shows the panel, a second tap
         on the same category follows the link. */
      btn.addEventListener('click', function (e) {
        if (!btn.classList.contains('is-active')) {
          e.preventDefault();
          activate(catIndex);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.pml-cascade-menu').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();

/* Menu pictures are fetched only when a menu is first opened, so closed menus add
   nothing to the page weight. Each picture keeps its address in data-src until then. */
(function () {
  function wire(details) {
    function loadPictures() {
      details.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
    details.addEventListener('toggle', function () {
      if (details.open) loadPictures();
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pml-mega-details').forEach(wire);
  });
})();

/* Top-level menu labels are links: hovering with a mouse opens the menu, clicking
   the label goes to the menu's main page, and the caret still opens or closes it.
   Touch screens: the first tap opens the menu, a second tap on the label follows the link. */
(function () {
  function wire(details, all) {
    var url = details.getAttribute('data-pml-href');
    var summary = details.querySelector('summary');
    if (!url || !summary) return;
    var openTimer, closeTimer;

    function closeOthers() {
      all.forEach(function (d) {
        if (d !== details && d.open) d.removeAttribute('open');
      });
    }
    function setOpen(state) {
      if (details.open === state) return;
      if (state) closeOthers();
      details.open = state;
      summary.setAttribute('aria-expanded', state ? 'true' : 'false');
    }

    details.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { setOpen(true); }, 90);
    });
    details.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { setOpen(false); }, 250);
    });

    summary.addEventListener('click', function (e) {
      if (e.target.closest('svg')) return;
      if (e.detail === 0) return;
      var isTouch = e.pointerType === 'touch' || (!e.pointerType && window.matchMedia('(hover: none)').matches);
      if (isTouch && !details.open) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = url;
    }, true);
  }
  document.addEventListener('DOMContentLoaded', function () {
    var all = Array.prototype.slice.call(document.querySelectorAll('.pml-mega-details'));
    all.forEach(function (d) { wire(d, all); });
  });
})();
